export default __webpack_public_path__ + "static/media/background_1920.dae54fc6.jpg";